import {
  PripomienkaFilter as PripomienkaFilterGenerated,
  PripomienkaFilterListApi,
  PripomienkaListItem as PripomienkaGenerated,
  PripomienkaListPage as PripomienkaListPageGenerated,
  SortDirectionEnum,
} from 'pripomienky-web-ts-axios';
import { AxiosRequestConfig } from 'axios';
import apiConfiguration from './configuration/apiConfiguration';
import { ClientResponse } from '../model/ClientResponse';
import ClassType, { classTypeToGenerated } from '../model/pripomienka/ClassType';
import Pripomienka from '../model/pripomienka/Pripomienka';
import {
  generatedToTypPripomienky,
  stringToGeneratedTyp,
} from '../model/pripomienka/TypPripomienky';
import {
  generatedToStavPripomienky,
  stringToGeneratedStav,
} from '../model/pripomienka/StavPripomienky';
import PripomienkaListPage from '../model/pripomienka/PripomienkaListPage';
import PripomienkyListFilter from '../model/filter/PripomienkyListFilter';
import dateToString from '../function/dateToString';
import { pripomienkyPrefixPath } from './configuration/apiConfigurationConstants';

const client = new PripomienkaFilterListApi(apiConfiguration(pripomienkyPrefixPath));

const mapPripomienkaItem = (generated: PripomienkaGenerated): Pripomienka => ({
  uuid: generated.uuid,
  text: generated.textPripomienky,
  typ: generatedToTypPripomienky(generated.typPripomienky),
  stav: generatedToStavPripomienky(generated.stav),
  odoslana: generated.odoslana,
  datumPripomienky: new Date(generated.datumPripomienky),
  pripomienkaK: generated.pripomienkaK,
  pripomienkujuciSubjekt: generated.pripomienkujuciSubjekt,
  pocetPodporovatelov: generated.pocetPodporovatelov,
  priradeny: generated.priradeny,
});

const map = (data: PripomienkaListPageGenerated): PripomienkaListPage => ({
  pripomienky: data.pripomienkaList.map(pripomienka => mapPripomienkaItem(pripomienka)),
  totalElements: data.totalElements,
  number: data.number,
  size: data.size,
});

export const mapPripomienkaFilter = (data: PripomienkyListFilter): PripomienkaFilterGenerated => ({
  typyPripomienok: data.typ ? data.typ.map(typPripomienky => stringToGeneratedTyp(typPripomienky)) : null,
  pripomienkujuceSubjekty: data.pripomienkujuciSubjekt,
  datumDoruceniaOd: dateToString(data.from),
  datumDoruceniaDo: dateToString(data.to),
  hladanyVyraz: data.text,
  vyhodnotenia: data.stav ? data.stav.map(stav => stringToGeneratedStav(stav)) : null,
  priradeniPouzivatelia: data.priradeny,
  nepriradenyPouzivatel: data.isNepriradeny,
});

// eslint-disable-next-line import/prefer-default-export
export const getPripomienkaFilterList = async (
  classType: ClassType,
  type: string,
  year: number,
  index: number,
  pripomienkaFilter: PripomienkyListFilter,
  page?: number,
  size?: number,
  sortBy?: string,
  sortDirection?: SortDirectionEnum,
  options?: AxiosRequestConfig,
):
    Promise<ClientResponse<PripomienkaListPage>> => {
  const {
    data,
    status,
  } = await client.getPripomienkaFilterList(
    classTypeToGenerated(classType),
    type,
    year,
    index,
    mapPripomienkaFilter(pripomienkaFilter),
    page,
    size,
    sortBy,
    sortDirection,
    options,
  );
  return {
    data: map(data), responseCode: status,
  };
};
